export interface Tariff {
  price_for_five: number;
  project_count_min: number;
  project_count_max: number | null;
}

export interface CostItem {
  from: number;
  to: number;
  price: number;
  description: string;
  note?: string;
  isCurrent?: boolean;
}

export interface ProjectCostItem {
  quantity: string;
  price: string;
}

export type AbTestsRaw = {
  quota: null | {
    currentQuotaId: number;
    quotaCount: number;
    expiredAt: string | Date;
    userId: number;
    price: number;
    type?: 'paid' | 'free' | 'deposit' | null;
  };
  unlimited: boolean;
} | null;

export const PROJECT_TARIFFS: Tariff[] = [
  { price_for_five: 0, project_count_min: 0, project_count_max: 5 },
  { price_for_five: 66, project_count_min: 5, project_count_max: 20 },
  { price_for_five: 33, project_count_min: 20, project_count_max: 40 },
  { price_for_five: 17, project_count_min: 40, project_count_max: null },
  // { price_for_five: 8, project_count_min: 100, project_count_max: null },
];

export const ACCOUNT_PRICE_PER_DAY = 50;

export const AB_PACKAGE_TEST_COUNT = 10;

export const PERIOD_AB_TEST_COUNT_PAID = AB_PACKAGE_TEST_COUNT;
export const PERIOD_AB_TEST_COUNT_FREE = 0;

export const AB_TESTS_COSTS_WITH_TARIFF: CostItem[] = [];

export const AB_TESTS_COSTS_WITHOUT_TARIFF: CostItem[] = [];

export const PROJECT_COST: ProjectCostItem[] = [
  {
    quantity: '5 шт.',
    price: 'Бесплатно',
  },
  {
    quantity: '6-20 шт.',
    price: '+66 ₽ / день',
  },
  {
    quantity: '21-40 шт.',
    price: '+33 ₽ /день',
  },
  {
    quantity: '41+ шт.',
    price: '+17 ₽ / день',
  },
  {
    quantity: '100+ шт.',
    price: '+8 ₽ / день',
  },
];

export const PHRASES_COST: CostItem[] = [
  {
    from: 0,
    to: 8000,
    price: 20,
    description: 'До 8K фраз',
  },
  {
    from: 8001,
    to: 10000,
    price: 80,
    description: 'До 10K фраз',
  },
  {
    from: 10001,
    to: 15000,
    price: 120,
    description: 'До 15K фраз',
  },
  {
    from: 15001,
    to: 20000,
    price: 220,
    description: 'До 20K фраз',
  },
  {
    from: 20001,
    to: 30000,
    price: 400,
    description: 'До 30K фраз',
  },
  {
    from: 30001,
    to: 50000,
    price: 700,
    description: 'До 50K фраз',
  },
  {
    from: 50001,
    to: Infinity,
    price: 1466,
    description: 'Безлимит',
  },
];

export interface TariffApi {
  title: string;
  type: string;
  description: string;
  options: string[];
  conditions: string[];
  price: string;
  isCurrent: boolean;
}

export type TariffsResponse = Record<string, TariffApi>;

export interface UserData {
  email: string;
  phone: string;
  reg_date: string;
  code: string;
  question_limit: number;
  account_count: number;
  sales_account_count: number;
  account_weekly_product_order_sum: number;
  account_weekly_product_sale_sum: number;
  active_module_ab: boolean;
  expiration_date_module_ab: string | false;
}

export interface SensitiveData {
  unique_queries: number;
  projects: number;
  queries: number;
  sales_month: number;
}
